const typelist = [{
        name: "业务数据",
        code: "200"
    },
    {
        name: "业务数据-点图层",
        code: "201"
    },
    {
        name: "业务数据-线图层",
        code: "202"
    },
    {
        name: "业务数据-面图层",
        code: "203"
    },
    {
        name: "业务数据-自定义图层",
        code: "204"
    },
    {
        name: "基础数据-影像图",
        code: "101"
    },
    {
        name: "基础数据-矢量图",
        code: "102"
    },
    {
        name: "基础数据-地形图",
        code: "103"
    },
    {
        name: "基础数据-三维白模",
        code: "104"
    },
    {
        name: "基础数据-街景",
        code: "105"
    },
    {
        name: "轨迹数据",
        code: "300"
    },
    {
        name: "云盘文件",
        code: "400"
    },
];
export default {
    typelist
};